import { create } from 'zustand';
import {
    IInteriorOrganizerCategoriesResponse, IInteriorOrganizerItemsResponse,
    IInteriorOrganizerPlacesResponse
} from '../interior-organizer-interfaces';
import { CategoriesTab } from '../ui/storage-item-categories/tabs-navigation';
import { PlacesTab } from '../ui/storage-places/tabs-navigation';
import { ItemsTab } from '../ui/storage-items/tabs-navigation';

interface InteriorOrganizerState {

    // -------- Item Categories -----------------------

    storageItemsCategoriesData: IInteriorOrganizerCategoriesResponse|null;
    setStorageItemsCategoriesData: (_storageItemsCategoriesData: IInteriorOrganizerCategoriesResponse|null) => void;

    categoriesTab: CategoriesTab;
    setCategoriesTab: (_categoriesTab: CategoriesTab) => void;

    // -------- Storage Places -----------------------

    storagePlacesData: IInteriorOrganizerPlacesResponse|null;
    setStoragePlacesData: (_storagePlacesData: IInteriorOrganizerPlacesResponse|null) => void;

    placesTab: PlacesTab;
    setPlacesTab: (_placesTab: PlacesTab) => void;

    placesFilterWidth: number;
    setPlacesFilterWidth: (_placesFilterWidth: number) => void;

    placesFilterHeight: number;
    setPlacesFilterHeight: (_placesFilterHeight: number) => void;

    placesFilterDepth: number;
    setPlacesFilterDepth: (_placesFilterDepth: number) => void;

    placesFilterName: string;
    setPlacesFilterName: (_placesFilterName: string) => void;

    // -------- Storage Items -----------------------

    storageItemsData: IInteriorOrganizerItemsResponse|null;
    setStorageItemsData: (_storageItemsData: IInteriorOrganizerItemsResponse|null) => void;

    itemsTab: ItemsTab;
    setItemsTab: (_itemsTab: ItemsTab) => void;

    itemsFilterWidth: number;
    setItemsFilterWidth: (_itemsFilterWidth: number) => void;

    itemsFilterHeight: number;
    setItemsFilterHeight: (_itemsFilterHeight: number) => void;

    itemsFilterDepth: number;
    setItemsFilterDepth: (_itemsFilterDepth: number) => void;

    itemsFilterName: string;
    setItemsFilterName: (_itemsFilterName: string) => void;
}

export const useInteriorOrganizerStore = create<InteriorOrganizerState>()((set) => ({

    // -------- Item Categories -----------------------

    storageItemsCategoriesData: null,
    setStorageItemsCategoriesData: (_storageItemsCategoriesData: IInteriorOrganizerCategoriesResponse|null) => {
        return set((state: InteriorOrganizerState) => {
            return {
                ...state,
                storageItemsCategoriesData: _storageItemsCategoriesData,
            };
        });
    },

    categoriesTab: CategoriesTab.Default,
    setCategoriesTab: (_categoriesTab: CategoriesTab) => {
        return set((state: InteriorOrganizerState) => {
            return {
                ...state,
                categoriesTab: _categoriesTab,
            };
        });
    },

    // -------- Storage Places -----------------------

    storagePlacesData: null,
    setStoragePlacesData: (_storagePlacesData: IInteriorOrganizerPlacesResponse|null) => {
        return set((state: InteriorOrganizerState) => {
            return {
                ...state,
                storagePlacesData: _storagePlacesData,
            };
        });
    },

    placesTab: PlacesTab.Default,
    setPlacesTab: (_placesTab: PlacesTab) => {
        return set((state: InteriorOrganizerState) => {
            return {
                ...state,
                placesTab: _placesTab,
            };
        });
    },

    placesFilterWidth: 0,
    setPlacesFilterWidth: (_placesFilterWidth: number) => {
        return set((state: InteriorOrganizerState) => {
            return {
                ...state,
                placesFilterWidth: _placesFilterWidth,
            };
        });
    },

    placesFilterHeight: 0,
    setPlacesFilterHeight: (_placesFilterHeight: number) => {
        return set((state: InteriorOrganizerState) => {
            return {
                ...state,
                placesFilterHeight: _placesFilterHeight,
            };
        });
    },

    placesFilterDepth: 0,
    setPlacesFilterDepth: (_placesFilterDepth: number) => {
        return set((state: InteriorOrganizerState) => {
            return {
                ...state,
                placesFilterDepth: _placesFilterDepth,
            };
        });
    },

    placesFilterName: '',
    setPlacesFilterName: (_placesFilterName: string) => {
        return set((state: InteriorOrganizerState) => {
            return {
                ...state,
                placesFilterName: _placesFilterName,
            };
        });
    },

    // -------- Storage Items -----------------------

    storageItemsData: null,
    setStorageItemsData: (_storageItemsData: IInteriorOrganizerItemsResponse|null) => {
        return set((state: InteriorOrganizerState) => {
            return {
                ...state,
                storageItemsData: _storageItemsData,
            };
        });
    },

    itemsTab: ItemsTab.Default,
    setItemsTab: (_itemsTab: ItemsTab) => {
        return set((state: InteriorOrganizerState) => {
            return {
                ...state,
                itemsTab: _itemsTab,
            };
        });
    },

    itemsFilterWidth: 0,
    setItemsFilterWidth: (_itemsFilterWidth: number) => {
        return set((state: InteriorOrganizerState) => {
            return {
                ...state,
                itemsFilterWidth: _itemsFilterWidth,
            };
        });
    },

    itemsFilterHeight: 0,
    setItemsFilterHeight: (_itemsFilterHeight: number) => {
        return set((state: InteriorOrganizerState) => {
            return {
                ...state,
                itemsFilterHeight: _itemsFilterHeight,
            };
        });
    },

    itemsFilterDepth: 0,
    setItemsFilterDepth: (_itemsFilterDepth: number) => {
        return set((state: InteriorOrganizerState) => {
            return {
                ...state,
                itemsFilterDepth: _itemsFilterDepth,
            };
        });
    },

    itemsFilterName: '',
    setItemsFilterName: (_itemsFilterName: string) => {
        return set((state: InteriorOrganizerState) => {
            return {
                ...state,
                itemsFilterName: _itemsFilterName,
            };
        });
    },

}));